import { render, staticRenderFns } from "./SupervisorAnalytics.vue?vue&type=template&id=2ea51a22"
import script from "./SupervisorAnalytics.ts?vue&type=script&lang=ts&external"
export * from "./SupervisorAnalytics.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
